// extracted by mini-css-extract-plugin
module.exports = {"category__wrapper":"CategoryCard_category__wrapper__QAUyZ","category__wrapper__content":"CategoryCard_category__wrapper__content__SGWF4"};